export default "__VITE_ASSET__C3vU4FDE__"